import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import Divider from 'material-ui/Divider'
import Typography from 'material-ui/Typography'
import Fade from 'material-ui/transitions/Fade'
import Icon from 'material-ui/Icon'
import HistoryNav from './HistoryNav'

const History = props => {
  const { compact, data, index, drawer } = props
  const { info: infoIndex, active: activeIndex, ...rest } = props

  const editType = _.get(drawer, 'drawerProps.config.valueTable.editType')

  if (compact)
    return (
      <Typography style={{ marginTop: 3 }} type="caption">
        {data && data.length} entries
      </Typography>
    )
  const currentRecord = data[activeIndex[index]]
  if (!currentRecord) return null

  const audit = currentRecord.audit
  let auditInfo = audit.createdBy
    ? `${audit.createdBy.toUpperCase()} created on ${moment(
        audit.createdDate
      ).format('DD/MM/YYYY hh:mm')}`
    : ''

  auditInfo += audit.modifiedBy
    ? (audit.createdBy ? ', modified on ' : 'Modified on ') +
      moment(audit.modifiedDate).format('DD/MM/YYYY hh:mm') +
      (audit.createdBy !== audit.modifiedBy
        ? ` by ${audit.modifiedBy.toUpperCase()}`
        : '')
    : ''

  const editDesc =
    _.get(_.find(editType, ['id', audit.editType]), 'label') || null
  if (editDesc) auditInfo += ` (${editDesc})`

  return (
    <div style={{ background: '#eee' }}>
      <Divider />
      <div
        style={{
          marginLeft: 24,
          marginTop: 12,
          marginBottom: 12,
          marginRight: 12,
          textAlign: 'left'
        }}
      >
        <Fade in>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: '0 0 30px' }}>
              <Icon>{infoIndex[index].icon}</Icon>
            </div>
            <div
              style={{
                marginLeft: 24,
                marginTop: 5,
                flex: '0 0 80px',
                color: audit.active ? '#004a6a' : '#999'
              }}
            >
              <Typography type="button">
                {audit.active
                  ? 'Active'
                  : audit.deactivated
                    ? 'Deactivated'
                    : 'History'}
              </Typography>
            </div>
            <div
              style={{
                marginLeft: 24,
                marginTop: 4,
                flex: 1,
                overflowX: 'hidden'
              }}
            >
              <span title={auditInfo}>
                <Typography noWrap>{auditInfo}</Typography>
              </span>
            </div>
            <div style={{ flex: '0 0 80px' }}>
              <HistoryNav
                info={infoIndex[index]}
                active={activeIndex[index]} //[index]}
                {...rest}
              />
            </div>
          </div>
        </Fade>
      </div>
      <Divider />
    </div>
  )
}

export default History



// WEBPACK FOOTER //
// ./src/common/components/History.js